module.exports = __webpack_public_path__ + "static/media/Teen_HoPro-mb-fr.8d266b66.jpg";